import { defineMessages } from 'react-intl';

const messages: {
	copyResponseLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	copyResponseLabel: {
		id: 'chatHistory.storeAssistant.copyResponseLabel',
		defaultMessage: 'Copy',
		description: 'Label for the copy response button',
	},
});

export default messages;
